import React,{PureComponent} from 'react'
import {Switch,Route, Redirect} from 'react-router-dom'

import DistributorList from "@pages/DistributorManagement/List/List"; // 列表
import ExtractDistributorList from "@pages/DistributorManagement/List/ExtractDistributorList"; // 提成分销列表
import DistributorEdit from "@pages/DistributorManagement/Edit/Index"; // 编辑
import DistributorAdd from "@pages/DistributorManagement/Add/Index"; // 新增
import Detail from "@pages/DistributorManagement/Detail/Index"; // 详情
import Settlement from "@pages/DistributorManagement/Settlement/Settlement"; //结算
import TotalMonthlySettlement from "@pages/DistributorManagement/Settlement/TotalMonthlySettlement"; //总代月度结算

class DistributorRouter extends PureComponent{
    render() {
        return (
            <Switch>
                <Route path="/distributor/list" component={DistributorList} />
                <Route path="/distributor/extractDistributionList" component={ExtractDistributorList} />
                <Route path="/distributor/settlement" component={Settlement} />
                <Route path="/distributor/totalMonthlySettlement" component={TotalMonthlySettlement} />
                <Route path="/distributor/edit" component={DistributorEdit} />
                <Route path="/distributor/add" component={DistributorAdd} />
                <Route path="/distributor/detail" component={Detail} />
                <Route path="/*" render={(props) => <Redirect to="/distributor/list" />} />
            </Switch>
        );
    }
}
export default DistributorRouter;